var _g, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstantTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 25C36.6667 31.45 31.45 36.6667 25 36.6667L26.75 33.75",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 15C3.33334 8.54998 8.55001 3.33331 15 3.33331L13.25 6.24998",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 6.99998V7.18331C36.6667 7.64998 36.3 8.01665 35.8333 8.01665H20.8333C20.3667 8.01665 20 7.64998 20 7.18331V6.99998C20 4.06665 20.7333 3.33331 23.7 3.33331H32.9667C35.9333 3.33331 36.6667 4.06665 36.6667 6.99998Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 9.68335C20.3667 9.68335 20 10.05 20 10.5167V12.1833V13.8333C20 16.7667 20.7333 17.5 23.7 17.5H32.9667C35.9333 17.5 36.6667 16.7667 36.6667 13.8333V12.1833V10.5167C36.6667 10.05 36.3 9.68335 35.8333 9.68335H20.8333Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.1667V26.35C20 26.8167 19.6333 27.1833 19.1667 27.1833H4.16668C3.70001 27.1833 3.33334 26.8167 3.33334 26.35V26.1667C3.33334 23.2333 4.06668 22.5 7.03334 22.5H16.3C19.2667 22.5 20 23.2333 20 26.1667Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16668 28.85C3.70001 28.85 3.33334 29.2166 3.33334 29.6833V31.35V33C3.33334 35.9333 4.06668 36.6666 7.03334 36.6666H16.3C19.2667 36.6666 20 35.9333 20 33V31.35V29.6833C20 29.2166 19.6333 28.85 19.1667 28.85H4.16668Z",
    fill: "#292D32"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.2667H40.6667",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 7.33331H36.9667C39.9333 7.33331 40.6667 8.06665 40.6667 11V17.85C40.6667 20.7833 39.9333 21.5166 36.9667 21.5166H27.7C24.7333 21.5166 24 20.7833 24 17.85V11C24 8.06665 24.7333 7.33331 27.7 7.33331Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 32.4333H24",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0333 26.5H20.3C23.2667 26.5 24 27.2333 24 30.1667V37.0167C24 39.95 23.2667 40.6833 20.3 40.6833H11.0333C8.06668 40.6833 7.33334 39.95 7.33334 37.0167V30.1667C7.33334 27.2333 8.06668 26.5 11.0333 26.5Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6667 29C40.6667 35.45 35.45 40.6667 29 40.6667L30.75 37.75",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 19C7.33334 12.55 12.55 7.33331 19 7.33331L17.25 10.25",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantTransfer);
export default __webpack_public_path__ + "static/media/instant-transfer.c183b895a1e00d98f847b720809599a8.svg";
export { ForwardRef as ReactComponent };